import React from "react";

export function Card( props ){return ( <img src={props.props.img} title= {props.props.seo} alt={props.props.name} decoding="sync" /> );}
